module.exports = __webpack_public_path__ + "static/story5-90611bbd839f71db3df172e19ae3bfd4.png";